import PaymentDetailsCard from './PaymentDetailsCard.component';

export default PaymentDetailsCard;
